import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { ClientsService, type Client } from '@/services/clients'

interface UseClientsParams {
    page: number
    searchTerm: string
    actiuFilter: string
    perPage?: number
}

interface ClientsResponse {
    data: Client[]
    meta: {
        current_page: number
        per_page: number
        total: number
        total_pages: number
    }
}

export function useClients({
    page,
    searchTerm,
    actiuFilter,
    perPage = 15
}: UseClientsParams) {
    return useQuery({
        queryKey: ['clients', { page, searchTerm, actiuFilter, perPage }],
        queryFn: async () => {
            const params = {
                page,
                search: searchTerm,
                actiu: actiuFilter === 'all' ? undefined : actiuFilter === 'actiu',
                per_page: perPage,
            }
            const response = await ClientsService.getAll(params)
            return response as ClientsResponse
        },
        placeholderData: keepPreviousData,
        staleTime: 1000 * 60 * 1, // 1 minute
    })
}
